import styled from 'styled-components'

export default styled('div')`
  background-color: #fff;
  border-radius: 2px;
  border: 1px solid #dcdcdc;
  padding: 25px;
`
